import { render, staticRenderFns } from "./BracBranchAccountShow.vue?vue&type=template&id=5a6989c7&"
import script from "./BracBranchAccountShow.vue?vue&type=script&lang=js&"
export * from "./BracBranchAccountShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports